import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type TabIconProps = Partial<SVGIconProps>;
const TabIcon = (props: TabIconProps) => {
  return (
    <SVGIcon height={49} viewBox="0 0 48 49" width={48} {...props}>
      <rect
        fill={props?.fill ?? "currentColor"}
        height="48"
        rx="24"
        width="48"
        y="0.601562"
      />
      <path
        clipRule="evenodd"
        d="M17 14.6016H31C32.1046 14.6016 33 15.497 33 16.6016V31.7559C33 33.1411 31.6259 34.1069 30.3226 33.6377L28.7608 33.0754C28.2728 32.8998 27.7356 32.9205 27.2626 33.1334L24.8207 34.2322C24.2988 34.4671 23.7012 34.4671 23.1793 34.2322L20.7374 33.1334C20.2644 32.9205 19.7272 32.8998 19.2392 33.0754L17.6774 33.6377C16.3741 34.1069 15 33.1411 15 31.7559V16.6016C15 15.497 15.8954 14.6016 17 14.6016ZM20 18.8516C19.5858 18.8516 19.25 19.1873 19.25 19.6016C19.25 20.0158 19.5858 20.3516 20 20.3516H24C24.4142 20.3516 24.75 20.0158 24.75 19.6016C24.75 19.1873 24.4142 18.8516 24 18.8516H20ZM20 22.8516C19.5858 22.8516 19.25 23.1873 19.25 23.6016C19.25 24.0158 19.5858 24.3516 20 24.3516H28C28.4142 24.3516 28.75 24.0158 28.75 23.6016C28.75 23.1873 28.4142 22.8516 28 22.8516H20ZM20 26.8516C19.5858 26.8516 19.25 27.1873 19.25 27.6016C19.25 28.0158 19.5858 28.3516 20 28.3516H28C28.4142 28.3516 28.75 28.0158 28.75 27.6016C28.75 27.1873 28.4142 26.8516 28 26.8516H20Z"
        fill="white"
        fillRule="evenodd"
      />
    </SVGIcon>
  );
};

export default TabIcon;
